export default __webpack_public_path__ + "static/media/paraEmpresas_02.4bd1a928.svg";